<template>
  <div>

    <div class="row data_privacy">

      <div class="col-1"></div>

      <div class="col-10">
<!--
        <div class="row header">
          <div class="col-12">
            <img class="logo" src="../../../assets/theme/default/img/pragyaLogo.svg" alt="Pragya Systems Logo">
          </div>
        </div>
-->
        <div class="row">
          <div class="col-12">
<!--
            <div class="pg_sec">
              <div class="pg_sec_head">
                Xprize Data
              </div>
              <div class="pg_sec_content">
                Your participation in Pragya platform is in conjunction with the
                XPRIZE Rapid Reskilling Competition. Evaluation of our team’s performance
                in the competition relies on the collection and sharing of your anonymized
                data. If you agree to the terms of use of this site, the following data will
                be tracked and shared with XPRIZE: training start date and training end date.
              </div>
              <div class="pg_sec_action">
                <input type="checkbox" id="tnc_chkbox" v-model="dataOptOut">
                I would like to opt-out of sharing my training data with XPrize
              </div>
            </div>
-->
            <div class="pg_sec" style="padding-bottom: 15px;">
              <div class="pg_sec_head">
                Support On Your Phone
              </div>
              <div class="pg_sec_content">
                We’ll text you motivation and reminders to support you during this program.
                Msg & data rates may apply, text STOP to end. If you don’t wish to receive these texts,
                please select Opt-out below.
              </div>
              <div class="pg_sec_action">
                <input type="checkbox" id="tnc_chkbox2" v-model="mobileDataOptOut">
                I would like to opt-out of receiving support on my mobile phone
              </div>
            </div>

          </div>
        </div>

        <div class="row btn_container">
          <div class="col-12">
            <button class="btn" @click="dataOptOutSave">Continue</button>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'dataPrivacy',
    props: ['userObj'],
    components: {
    },
    data: () => {
      return {
        index: 0,
        dataOptOut: false,
        mobileDataOptOut: false
      }
    },
    mounted () {
      if (!this.userObj) {
        this.userObj = JSON.parse(localStorage.getItem('userobj'))
      }
      this.dataOptOut = this.userObj.dataOptOut
      this.mobileDataOptOut = this.userObj.mobileDataOptOut
    },
    methods: {
      ...mapActions([
        'setUserInfo',
        'loadSaveUser',
        'loadInstitutionInfo',
        'loadSaveDataOptOut'
      ]),
      showLoader () {
        this.$parent.$refs.loadingModal.show()
      },
      hideLoader () {
        this.$parent.$refs.loadingModal.hide()
      },
      async dataOptOutSave () {
        this.showLoader()
        var formData = new FormData()
        formData.append('dataOptOut', this.dataOptOut)
        formData.append('mobileDataOptOut', this.mobileDataOptOut)
        let res = await this.loadSaveDataOptOut(formData)
        localStorage.setItem('userobj', JSON.stringify(res))
        this.hideLoader()
        this.navigateToDashboard(res.roles[0].role)
      },
      navigateToDashboard (userRole) {
        this.$parent.isUserLoggedIn = true
        this.$parent.isServiceAvailable = true
        let role = userRole.toLowerCase()
        let url = '/user/track/' + role
        if ((role === 'instructor & admin') || (role === 'curator')) {
          url = '/user/track/admin'
        } else if (role === 'employer admin') {
          url = '/employer/admin'
        } else if (role === 'prospective student' || role === 'admitted student' || role === 'widget admin') {
          url = '/user/track/' + role.split(' ').join('_')
        }
        return this.$router.push(url)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/user/components/DataPrivacy.vue